import React, { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import { useSelector } from 'react-redux';
import PartialProductCard from "../partialProductCard/PartialProductCard";
import { RootState } from "../../redux/rootReducer";
import styles from "./BestSeller.module.css";
import './BestSeller.module.css';
import { colorCodes } from '../../utilities/settings'
import { Carousel } from "react-responsive-carousel";

export interface IPartialProductCard {
    itemId: number,
    itemCode: string,
    itemDescription: string,
    assetURL: string,
    modelCode: string,
    unitPrice: number,
    displayOrder: number,
    brand: any,
    itemName: string,
    newPrice: number,
    isOfferAvailable: boolean,
    isNewArrival: boolean,
    isInStock: boolean
}

interface PropsType {
    productCard: IPartialProductCard[]
}

export function selectColorCode(n: number) {
    var val = (n % 4);
    return val;
}

export default function BestSellerModule(props: PropsType) {
    const responsive = useSelector((state: RootState) => state.responsive);
    const [productList, setproductList] = useState<IPartialProductCard[]>(props.productCard.slice(0, 4));

  return(    
    <React.Fragment> 
        {
            productList.length > 0 ?
            <>
                <Row>
                    <Col lg="12" md="12" xs="12" className={`${styles.mainHeading}`}>
                        <span>BEST SELLERS</span>
                    </Col>
                    <Col className={`${styles.description}`} hidden>
                        <p>Lorem ipsum dolor sit amet. Ea quia obcaecati qui excepturi perspiciatis et explicabo explicabo. 
                            Et earum nihil sit minus libero sit voluptatem reprehenderit qui facilis laboriosam et iste sequi.</p>
                    </Col>
                </Row>
                <Row style={{ padding: "0", margin: "0", zIndex: -1, minHeight: "300px", marginBottom: "2rem" }}>      
                {
                    responsive.isMobileLargeScreen || responsive.isMobileSmallScreen || responsive.isTabScreen ?
                        <Carousel autoPlay={true} showArrows={false}  swipeable={true} showStatus={false}  infiniteLoop={true}
                            showIndicators={true}  showThumbs={false} >
                                {
                                    productList.filter((item : any)=> item.isActive === true).map((item: IPartialProductCard, index) => {
                                        return (
                                            <div key={index} className=" justify-content-center">
                                                <div className={`${styles.imgContainer}`} style={{ margin: "2.5rem" }} >
                                                    <Col>
                                                        <PartialProductCard key={item.itemId} productCard={item} colorCode={colorCodes[selectColorCode(index)]}></PartialProductCard>
                                                    </Col>
                                                </div>
                                            </div>
                                        );
                                    })
                                }
                        </Carousel>
                    :
                    productList.filter((item : any)=> item.isActive === true).map((item: IPartialProductCard, index) => {
                        return (
                            <Col xl="3" lg="3" md="6" sm="6" xs="6">
                                <PartialProductCard key={item.itemId} productCard={item} colorCode={colorCodes[selectColorCode(index)]}></PartialProductCard>
                            </Col>                      
                        );
                    })
                }
                </Row>
            </> : null
        }
    </React.Fragment>
  )
}